import React__default from "react";
import "debounce";
import "tabbable";
import { useResponsiveProps } from "../../helpers/helper/hooks/use-responsive-props.mjs";
import { Image } from "../../image/image.mjs";
import { ObjectFit } from "../../object-fit/object-fit.mjs";
import { Tag } from "../../tag/tag.mjs";
import { BannerHeading } from "../banner-heading/banner-heading.mjs";
const BannerItemResponsive = (props) => {
  const { responsive, children, ...rest } = props;
  const responsiveProps = useResponsiveProps({
    responsive
  });
  return /* @__PURE__ */ React__default.createElement(BannerItemInner, { ...rest, ...responsiveProps }, children);
};
const BannerItemInner = (props) => {
  const { image, className, id, tag, heading, padding, tagPosition = "left", children } = props;
  const BEM = () => {
    const classArray = ["banner-item"];
    if (tagPosition) {
      classArray.push("banner-item__tag-".concat(tagPosition));
    }
    const addPaddingClass = (direction, size) => {
      if (size) {
        return classArray.push("banner-item--padding-".concat(direction, "-").concat(size));
      }
    };
    if (padding) {
      if (typeof padding === "string") {
        classArray.push("banner-item--padding-".concat(padding));
      } else {
        Object.keys(padding).forEach((key) => {
          const direction = key;
          addPaddingClass(direction, padding[direction]);
        });
      }
    }
    return classArray.join(" ");
  };
  const innerBEM = () => {
    const classArray = ["banner-item__inner"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const imageBEM = (image2) => {
    const classArray = ["banner-item__image"];
    if (image2 && image2.className) {
      classArray.push(image2.className);
    }
    return classArray.join(" ");
  };
  const renderImage = () => {
    return /* @__PURE__ */ React__default.createElement(ObjectFit, { fit: "cover", positionX: "center", positionY: "center" }, /* @__PURE__ */ React__default.createElement(Image, { ...image, className: imageBEM(image), pictureClassName: "banner-item__image-picture" }));
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: BEM(), id }, /* @__PURE__ */ React__default.createElement("div", { className: "banner-item__image-column" }, renderImage()), tag && /* @__PURE__ */ React__default.createElement(Tag, { ...tag, className: "banner-item__tag" }), /* @__PURE__ */ React__default.createElement("div", { className: "banner-item__content-column" }, /* @__PURE__ */ React__default.createElement("div", { className: innerBEM() }, heading && /* @__PURE__ */ React__default.createElement(BannerHeading, { ...heading }), /* @__PURE__ */ React__default.createElement("div", { className: "banner-item__content" }, children))));
};
const BannerItem = (props) => {
  const { responsive, children, ...rest } = props;
  return responsive ? /* @__PURE__ */ React__default.createElement(BannerItemResponsive, { ...rest, responsive }, children) : /* @__PURE__ */ React__default.createElement(BannerItemInner, { ...rest }, children);
};
export {
  BannerItem
};
